import { InjectionToken } from '@angular/core';

export const SSR_IS_MOBILE = new InjectionToken<boolean>('SSR_IS_MOBILE');